import Vacation from '../../../shared/images/vacation.svg';
import {LABELS} from '../../../shared/labels/Labels';
import {XeroSignupAction} from '../../actions';
import BulletList from './components/BulletList/BulletList';
import RedirectCountdownBanner from './components/RedirectCountdownBanner/RedirectCountdownBanner';
import {
  Container,
  LeftColumn,
  RightColumn,
  SectionContainer,
  SectionContentWrapper,
  StyledIcon,
  StyledSpinner,
  StyledTextWrapper,
  VacationImage,
} from './styled';
import {useGlobalization} from '@planday-corp/globalization';
import Section from '@planday-corp/ui/structure/Section';
import Text from '@planday-corp/ui/text/Text';
import React, {useEffect} from 'react';

const LIST_SEPARATOR = ';';

interface LoadingScreenProps {
  redirectToPortalAction: () => XeroSignupAction;
  isPortalCreationInProgress: boolean;
}

export default function LoadingScreen({
  redirectToPortalAction,
  isPortalCreationInProgress,
}: LoadingScreenProps) {
  const {i18n} = useGlobalization();

  useEffect(() => {
    if (!isPortalCreationInProgress) {
      redirectToPortalAction();
    }
  }, [isPortalCreationInProgress]);

  return (
    <Container>
      <LeftColumn>
        <VacationImage src={Vacation} />
        <StyledTextWrapper>
          <Text
            size="title1"
            element="h1"
            value={LABELS.onboardingExampleStepsTitle}
          />
          <BulletList
            items={i18n
              .t(LABELS.onboardingExampleStepsList)
              .split(LIST_SEPARATOR)}
          />
        </StyledTextWrapper>
      </LeftColumn>
      <RightColumn>
        <SectionContainer>
          <Section
            title={
              isPortalCreationInProgress
                ? LABELS.onboardingStatusInProgress
                : LABELS.onboardingStatusFinished
            }
          >
            {!isPortalCreationInProgress && (
              <RedirectCountdownBanner
                handleRedirect={redirectToPortalAction}
              />
            )}

            <SectionContentWrapper>
              {isPortalCreationInProgress ? (
                <StyledSpinner color="grey50" />
              ) : (
                <StyledIcon iconName="access" color="green50" />
              )}
            </SectionContentWrapper>
          </Section>
        </SectionContainer>
      </RightColumn>
    </Container>
  );
}
